<template>
  <QBtn
    flat
    round
    text-color="primary"
    :icon="icon"
    class="profile-button"
    :ripple="false"
  >
    <QBadge
      floating
      color="negative"
      v-if="alert"
      class="alert-badge row justify-center items-center text-weight-medium"
      :label="alert"
    />
    <QMenu
      fit
      transition-show="scale"
      transition-hide="scale"
      :offset="[0, 8]"
      anchor="bottom right"
      self="top right"
      class="profile-menu"
      content-class="borders-rounded-lg profile-menu"
      style="min-width: 300px"
    >
      <QList>
        <QItem v-if="email || name">
          <QItemSection class="column q-gutter-y-xs q-py-md">
            <span
              v-if="name"
              class="text-no-wrap text-weight-medium text-grey-10"
            >
              {{ name }}
            </span>
            <span v-if="email" class="text-no-wrap text-grey-6">
              {{ email }}
            </span>
          </QItemSection>
        </QItem>
        <QSeparator color="grey-3" v-if="name || email" />
        <slot />
        <QSeparator color="grey-3" v-if="$slots.default" />
        <QItem v-close-popup clickable v-if="!hideLogout">
          <QItemSection @click="$emit('logout')">
            <div class="row no-wrap items-center">
              <QIcon name="eva-log-out-outline" size="21px" class="q-mr-sm" />
              <span>Logout</span>
            </div>
          </QItemSection>
        </QItem>
      </QList>
    </QMenu>
  </QBtn>
</template>

<script>
import {
  QBtn,
  QMenu,
  QList,
  QItem,
  QItemSection,
  ClosePopup,
  QBadge,
  QSeparator,
  QIcon
} from 'quasar';

export default {
  name: 'SAIProfileMenu',
  props: {
    hideLogout: Boolean,
    alert: Number,
    name: String,
    email: String,
    icon: {
      type: String,
      default: 'eva-person-outline'
    }
  },
  directives: {
    ClosePopup
  },
  components: {
    QBtn,
    QMenu,
    QList,
    QItem,
    QItemSection,
    QBadge,
    QSeparator,
    QIcon
  }
};
</script>

<style lang="sass" scoped>
.profile-button::v-deep .icon-person-outline
  font-size: 32px

.alert-badge::v-deep
  padding: 3px 6px
  border-radius: 25px
  right: -2px
  bottom: 0
  top: initial

.profile-menu::v-deep
  .q-item.q-item--clickable:hover
    color: $primary
</style>
